import { render, staticRenderFns } from "./application-center-home.vue?vue&type=template&id=395a38d6&scoped=true&"
import script from "./application-center-home.vue?vue&type=script&lang=js&"
export * from "./application-center-home.vue?vue&type=script&lang=js&"
import style0 from "./application-center-home.vue?vue&type=style&index=0&id=395a38d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a38d6",
  null
  
)

export default component.exports